import styled from "styled-components";
import { Body1 } from "@arcteryx/components-typography";

export const Div = styled.div`
  display: inline-block;
  position: relative;
  bottom: -1px;
  padding: 5px;
  height: max(${props => props.size}, 20px);
  color: transparent;

  cursor: pointer;
  &:after {
    content: ${props => `url(//images.arcteryx.com/foundation-ui/svgs/${props.icon}.svg)`};
    width: ${props => props.size};
    height: ${props => props.height};
    display: inline-block;
  }
`;

export const TooltipText = styled.span`
  ${props => !props.displayTooltip && `display: none;`}

  --vWidth: 360px;
  --vMinWidth: min(${props => props.maxWidth}px, var(--vWidth));

  position: absolute;
  width: var(--vWidth);
  background: var(--colour-black);
  color: var(--colour-white);
  box-shadow: 6px 6px 6px #1A1A1A29;
  padding: 1rem;
  font-size: 1rem;
  line-height: 1.5rem;
  z-index: 999;

  max-height: ${props => `${props.maxHeight}px`};
  max-width: ${props => `${props.maxWidth}px`};

  ${props =>
    props.arrowDirection === "top" &&
    `
    top: 160%;
    left: 50%;
    margin-left: calc(-1 * var(--vMinWidth) / 2 + ${props.size} / 2);
    &:after {
      top: -6px;
      transform: rotate(180deg);
    }
  `}
  // Defaults to bottom
  ${props =>
    props.arrowDirection === "bottom" &&
    `
    bottom: 110%;
    left: 50%;
    margin-left: calc(-1 * var(--vMinWidth) / 2 + ${props.size} / 2);
    &:after {
      bottom: -6px;
    }
  `}
  ${props =>
    props.arrowDirection === "left" &&
    `
    width: max-content;
    left: 100%;
    &:after {
      top: 4px;
      left: -0.667rem !important;
      transform: rotate(90deg);   
    }
  `}
  ${props =>
    props.arrowDirection === "right" &&
    `
    width: max-content;
    right: 100%;
    &:after {
      top: 4px;
      right: -0.7rem !important;
      transform: rotate(-90deg);
    }
  `}

  &:after {
    position: absolute;
    content: "";
    display: var(--colour-black);
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-bottom-width: 0;
    border-top-color: var(--colour-black);
    right: 50%;
  }
`;

export const TooltipWrapper = styled.span`
  align-items: center;
  max-width: 360px;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr auto;
  display: grid;
`;

export const TooltipTipImg = styled.img`
  height: 50px;
  width: 150px;
  position: relative;
  display: inline-block;
  margin: 0.5rem 0;
  background: var(--colour-black);
`;

export const Content = styled(Body1).attrs({ tag: "span" })`
  grid-column: 1/3;
  overflow: hidden;
`;
